import React from "react";
import { useSelector } from "react-redux";

const MyComponent = () => {
  const item = useSelector((state) => state.users[0]);
  console.log("test data", item);

  return (
    <div>
      <h1>My Data from Redux Store</h1>
      {/* {myData.map((item, index) => (
        <div key={index}> */}
      <p>Item: {item.userId}</p>
      <p>Value: {item.accountId}</p>
      <p>accountName: {item.accountName}</p>
      <p>customerName:{item.name}</p>
      <p>email:{item.email}</p>
      <p>financialYear:{item.customerSince}</p>
      <p></p>
    </div>
    // ))}
    // </div>
  );
};

export default MyComponent;
